import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BuilderInfoService } from '@portal/builder';

@Pipe({
  name: 'multilang',
  pure: true,
  standalone: false,
})
export class MultiLangPipe implements PipeTransform {
  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private readonly builderInfoService: BuilderInfoService,
    // eslint-disable-next-line @angular-eslint/prefer-inject
    private readonly translateService: TranslateService,
  ) {}
  transform(value: unknown, lookupLang?: string): string {
    if (typeof value === 'string') {
      return value;
    }

    if (typeof value === 'object' && value !== null) {
      return value?.[lookupLang] ?? this.getValueByActiveLangOrDefault(value as Record<string, string>);
    }
    if (!value) {
      return '';
    }

    return value as string;
  }

  private getValueByActiveLangOrDefault(value: Record<string, string>): string {
    const defaultLang = this.builderInfoService.lang;
    const activeLange = this.translateService.currentLang.toUpperCase();

    const showValue = value[activeLange] ?? value[defaultLang];
    if (showValue) {
      return showValue;
    }

    if (Object.keys(defaultLang).length === 0) {
      return '';
    }

    return value[Object.keys(value)[0]] ?? '';
  }
}
